import ProgressBar from 'react-toolbox/lib/progress_bar/ProgressBar'
import { compose, defaultProps } from 'recompose'

import { withTheme } from 'modules/util'

import progressBarTheme from './theme.scss'

export default compose(
  defaultProps({ multicolor: true, type: 'circular', mode: 'indeterminate' }),
  withTheme(progressBarTheme)
)(ProgressBar)



// WEBPACK FOOTER //
// ./client/modules/ui/components/ProgressBar/index.js